<template>
  <div class="" tile>
    <!-- <v-system-bar color="deep-purple darken-3"></v-system-bar> -->

    <v-app-bar color="blue darken-4" dark fixed>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title> Sistema ESAM </v-toolbar-title>

      <v-spacer></v-spacer>

      <!--  <v-btn icon>
        <v-icon>mdi-magnify</v-icon>
      </v-btn> -->

      <v-select
        :items="$store.state.CARGOS"
        item-text="nombre"
        v-model="$store.state.CARGO"
        return-object
        dense
        hide-details
      ></v-select>

      <v-btn icon @click="perfil">
        <v-icon>mdi-account</v-icon>
      </v-btn>

      <v-menu left bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-list-item-title @click="salir()">Salir</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" absolute bottom temporary fixed>
      <!-- <v-list nav dense>
        <v-list-item-group v-model="group" active-class="deep-purple--text text--accent-4">
          <v-list-item v-for="(menu, ind) in $store.state.MENUS" :key="ind">
            <v-list-item-title> {{ menu }} </v-list-item-title>
          </v-list-item>
        </v-list-item-group>
      </v-list> -->

      <div xstyle="position:relative">
        <!-- <img src="@/assets/./user-default.png" alt="PERFIL" id="btn-expand-hi" class="text-center" style="width: 40px;margin: 8px auto;display:grid" /> -->
        <img
          :src="profile"
          alt="PERFIL"
          id="btn-expand-hi"
          class="text-center div-expand"
          style="width: 60px; margin: 8px auto; display: grid; border-radius: 50%"
        />
        <!-- <img class='web-avatar-left' src='https://vidriera-crear.rionegro.gov.ar/img/adornos_navidad/adorno_img_emprendimiento.png'>
                <img class='web-avatar-bright' src='https://vidriera-crear.rionegro.gov.ar/img/adornos_navidad/adorno_img_emprendimiento.png'>
                 -->
        <p class="text-center main-name" style="margin: 0; color: #1177d1; font-size: 13px; font-weight: bold">
          {{ $store.state.DATA_USER.nombres }}
          {{ $store.state.DATA_USER.pri_apellido }}
        </p>
        <div style="height: 25px; background: rgb(236, 238, 227)"></div>
      </div>

      <li v-bind:key="menu.id" v-for="menu in $store.state.MENUS">
        <router-link v-if="menu.nombre == 'Contactos'" v-bind="{ to: menu.enlace }" :title="menu.nombre">
          <svg
            width="1.15em"
            height="1.15em"
            viewBox="0 0 16 16"
            class="bi bi-file-earmark-person-fill"
            fill="#1177D1"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fill-rule="evenodd"
              d="M2 2a2 2 0 0 1 2-2h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm7.5 1.5v-2l3 3h-2a1 1 0 0 1-1-1zM11 8a3 3 0 1 1-6 0 3 3 0 0 1 6 0zm2 5.755S12 12 8 12s-5 1.755-5 1.755V14a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-.245z"
            />
          </svg>
          <span class="nav-label"> Mi Base de datos</span>
        </router-link>

        <div v-else-if="menu.nombre == 'Cargos'" style="position: relative">
          <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseSistema">
            <span class="glyphicon glyphicon-cog"></span>
            <span class="nav-label"> Sistema <span class="glyphicon glyphicon-chevron-down expand-right"></span> </span>
          </router-link>

          <div class="collapse" id="collapseSistema">
            <router-link :to="'/cargos'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Cargos</span>
            </router-link>
            <router-link :to="'/sedes'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Sedes </span>
            </router-link>
            <router-link :to="'/usuarios'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Usuarios </span>
            </router-link>
            <!-- <router-link v-if="$store.state.CARGO.id == 1" :to="'/unidades'" title="Gestionar unidades">
                                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                <span class="nav-labe">Unidades</span>
                            </router-link>
                            <router-link v-if="$store.state.CARGO.id == 1" :to="'/conceptospago'" title="Gestionar Concetos pago">
                                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                <span class="nav-labe">Conceptos</span>
                            </router-link>
                            <router-link v-if="$store.state.CARGO.id == 1" :to="'/xsucursales'" title="Gestionar Sucursales">
                                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                <span class="nav-labe">Sucursales</span>
                            </router-link> -->
          </div>
        </div>

        <div v-else-if="menu.nombre == 'Mis inscripciones'" style="position: relative">
          <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseMarketing">
            <span class="glyphicon glyphicon-bullhorn"></span>
            <span class="nav-label">
              Marketing <span class="glyphicon glyphicon-chevron-down expand-right"></span>
            </span>
          </router-link>

          <div class="collapse" id="collapseMarketing">
            <router-link :to="'/misinscripciones'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Inscripciones</span>
            </router-link>
            <router-link :to="'/contactos'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Base de datos</span>
            </router-link>
          </div>
        </div>

        <div v-else-if="menu.nombre == 'Postgrados'" style="position: relative">
          <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseAcademico">
            <span class="glyphicon glyphicon-education"></span>
            <span class="nav-label">
              Academico <span class="glyphicon glyphicon-chevron-down expand-right"></span>
            </span>
          </router-link>

          <div class="collapse" id="collapseAcademico">
            <router-link
              :to="'/postgrados'"
              title="''"
              v-if="
                $store.state.CARGO.id != 11 &&
                  $store.state.CARGO.id != 12 &&
                  $store.state.CARGO.id != 13 &&
                  $store.state.CARGO.id != 14 &&
                  $store.state.CARGO.id != 15 &&
                  $store.state.CARGO.id != 25
              "
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> {{ $store.state.unidad.postgrados }} </span>
            </router-link>
            <router-link :to="'/programas'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> {{ $store.state.unidad.programas }} </span>
            </router-link>
            <router-link
              :to="'/xprogramas'"
              title="Programas Siglo XX"
              v-if="$store.state.CARGO.id == 1 || $store.state.CARGO.id == 170 || $store.state.CARGO.id == 60"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Prog. Siglo XX </span>
            </router-link>
            <!-- <router-link :to="'/calificacionesv2'" title="''">
                              <span
                                class="glyphicon glyphicon-minus"
                                style="margin-left: 26px"
                              ></span>
                              <span class="nav-labe"> Calificaciones </span>
                            </router-link> -->
            <router-link :to="'/personas'" title="''">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Personas </span>
            </router-link>
            <router-link
              v-if="$store.state.CARGO.id == 8 || $store.state.CARGO.id == 1"
              :to="'/plataformas'"
              title="''"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Plataformas </span>
            </router-link>
          </div>
        </div>

        <!-- OCULTA EL MENU CONTABILIDAD PARA MARKETEROS -->
        <div
          v-else-if="menu.nombre == 'Facturas' && ($store.state.CARGO.id == 13 || $store.state.CARGO.id == 12)"
          style="position: relative;"
        ></div>

        <div v-else-if="menu.nombre == 'Facturas'" style="position: relative;">
          <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseContabilidad">
            <span class="glyphicon glyphicon-credit-card"></span>
            <span class="nav-label">
              Contabilidad <span class="glyphicon glyphicon-chevron-down expand-right"></span>
            </span>
          </router-link>

          <div class="collapse" id="collapseContabilidad" v-if="$store.state.CARGO.id != 13">
            <router-link :to="'/recibos'" title="'Efectivos'" v-if="$store.state.CARGO.sede.id != 19">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Recibos</span>
            </router-link>
            <router-link
              v-if="($store.state.CARGO.id == 21 && $store.state.CARGO.sede.id == 19) || $store.state.CARGO.id == 1"
              :to="'/recibosbenito'"
              title="'Recibos Para Univ. Benito Juarez'"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Recibos Juarez</span>
            </router-link>
            <router-link :to="'/facturaslista'" title="Facturas por sede">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Facturas</span>
            </router-link>
            <router-link
              v-if="
                $store.state.DATA_USER.id == 31 ||
                  $store.state.DATA_USER.id == 6457 ||
                  $store.state.CARGO.id == 18 ||
                  $store.state.CARGO.id == 1
              "
              :to="'/facturaslistaext'"
              title="'Facturas externo'"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Facturas Nal.</span>
            </router-link>
            <router-link
              v-if="
                $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 1
              "
              :to="'/descuentoslista'"
              title="'Reporte mensual editable'"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Descuentos </span>
            </router-link>
            <router-link
              v-if="$store.state.CARGO.id == 19 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 1"
              :to="'/motivos-descuento'"
              title="Motivos de descuentos"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Motivos Des.</span>
            </router-link>
            <router-link
              v-if="
                $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 1 ||
                  $store.state.CARGO.id == 3 ||
                  $store.state.CARGO.id == 17
              "
              :to="'/asignacionesmenu'"
              title="Asignaciones"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Asignaciones</span>
            </router-link>
            <router-link
              v-if="
                $store.state.CARGO.id == 19 ||
                  $store.state.CARGO.id == 14 ||
                  $store.state.CARGO.id == 15 ||
                  $store.state.CARGO.id == 1
              "
              :to="'/contratoslista'"
              title="Ver contratos generados"
            >
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Contratos</span>
            </router-link>
            <!-- <router-link v-if="$store.state.CARGO.id == 19 || $store.state.CARGO.id == 14 || $store.state.CARGO.id == 15 || $store.state.CARGO.id == 1" :to="'/asignacionesv2s'" title="Asignaciones por sede">
                                <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
                                <span class="nav-labe">Asig. sedes</span>
                            </router-link> -->
            <router-link :to="'/AntiguosRecibos'" title="'Antiguos recibos'" v-if="!$store.state.isonlyread">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Rec. Antiguos </span>
            </router-link>
          </div>
        </div>

        <router-link v-else-if="menu.nombre != 'Dashboard'" v-bind="{ to: menu.enlace }" :title="menu.nombre">
          <span :class="menu.icono"></span>
          <span class="nav-label">{{ menu.nombre == 'Postgrados' ? menu_name : menu.nombre }}</span>
        </router-link>

        <div v-else-if="menu.nombre == 'Dashboard'" style="position: relative">
          <router-link :title="menu.nombre" to="" data-toggle="collapse" data-target="#collapseExampled">
            <span class="glyphicon glyphicon-stats"></span>
            <span class="nav-label">
              Dashboard <span class="glyphicon glyphicon-chevron-down expand-right"></span>
            </span>
          </router-link>

          <div class="collapse" id="collapseExampled">
            <router-link :to="'/efectivos'" title="'Efectivos'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Efectivos</span>
            </router-link>
            <router-link :to="'/xreporte'" title="'Reporte mensual editable'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Reporte Marketing </span>
            </router-link>
            <router-link :to="'/xreporteporsede'" title="'Reporte todos por sede'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Reporte Mkt2 </span>
            </router-link>
            <router-link :to="'/xreportec'" title="'Reporte mensual editable'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe"> Reporte Semanas</span>
            </router-link>
            <router-link :to="'/semaforo'" title="'Semaforo'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Semaforo</span>
            </router-link>
            <router-link :to="'/semaforopro'" title="Programas">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Programas</span>
            </router-link>
            <router-link :to="'/semaforoins'" title="'Semaforo'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Ins. por sede</span>
            </router-link>
            <router-link :to="'/semaforosed'" title="'Semaforo'">
              <span class="glyphicon glyphicon-minus" style="margin-left: 26px"></span>
              <span class="nav-labe">Ins. por programa</span>
            </router-link>
            <!-- <router-link :to="'/semaforosline'" title="'Semaforo'">
                <span class="glyphicon glyphicon-minus" style="margin-left:26px;"></span>
                <span class="nav-label"> Evolucion </span>
              </router-link> -->
          </div>
        </div>
      </li>
    </v-navigation-drawer>

    <v-card>
      <router-view />
    </v-card>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  import { mapMutations } from 'vuex';
  export default {
    data: () => ({
      drawer: false,
      group: null,
      menus: [],
      profile: 'img/user-default.png',
    }),

    watch: {
      group() {
        this.drawer = false;
      },
      '$store.state.CARGO': function(a) {
        if (a != null) {
          this.setCargoSedeStore(a);
          window.sessionStorage.setItem('XCARGO', JSON.stringify(a));
        }
        this.cargardata();
        // window.console.log( "CAMBIO CARGOOO ",a );
        this.parseMenus();
        this.$store.state.isonlyread = this.$store.state.CARGO.id == 22;
        //this.verificarPermisos();
      },
    },
    methods: {
      ...mapMutations(['setCargoSedeStore', 'setCargosWithSedeStore']),
      getme() {
        this.$apollo
          .query({
            query: gql`
              query {
                me {
                  datos_personales {
                    id
                    sexo
                    nombres
                    pri_apellido
                    seg_apellido
                    estado
                    tipo
                    usuario {
                      foto
                      firma
                      correo_corp
                    }
                  }
                  cargos {
                    idsede
                    cargo {
                      id
                      nombre
                    }
                    sede {
                      id
                      nombre
                      unidad_negocio
                    }
                    desde
                    hasta
                  }
                }
              }
            `,
          })
          .then(({ data: { me } }) => {
            window.console.log(me);
            if (me == null) {
              this.salir();
            } else {
              this.$store.state.me = me;
              this.$store.state.DATA_USER = me.datos_personales;
              if (me.datos_personales.sexo == 'F') this.profile = 'img/user-default2.png';
              try {
                var user = me.datos_personales.usuario;
                if (user) {
                  var foto = user.foto;
                  if (foto && foto.includes('.')) this.profile = this.location_user_pick + foto;
                }
              } catch (error) {
                window.console.error(error);
              }
              this.$store.state.CARGO = me.cargos[0];
              this.parseCargos();
              this.getGestiones();
              this.getCategorias();
              this.getSedes();
            }
          })
          .catch((error) => {
            window.console.error(error);
          });
      },

      parseCargos() {
        var vue = this;
        this.$store.state.me.cargos.forEach(function(e) {
          if (!e.sede) e.sede = {};
          var ca = e.cargo.nombre;
          var se = e.sede.nombre;
          vue.$store.state.CARGOS.push({
            id: e.cargo.id,
            idsede: e.sede.id,
            nombre: ca + ' - ' + se,
            cargo: e.cargo,
            sede: e.sede,
          });
        });
        this.$store.state.CARGO = vue.$store.state.CARGOS[0];
        this.setCargosWithSedeStore(this.$store.state.CARGOS);
        this.setCargoSedeStore(this.$store.state.CARGO);
      },
      getGestiones() {
        this.$apollo
          .query({
            query: gql`
              query {
                getGestiones {
                  gestion
                  apertura
                  cierre
                }
              }
            `,
          })
          .then(({ data: { getGestiones } }) => {
            const data = getGestiones.reverse();
            this.$store.dispatch('gestion/setGestiones', data);
            this.$store.dispatch('gestion/addGestion', { gestion: 'todos' });
            this.$store.dispatch('gestion/selectGestion', data.length ? data[0] : null);
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
      getCategorias() {
        this.$apollo
          .query({
            query: gql`
              query {
                getCategorias {
                  id
                  nombre
                  descripcion
                  estado
                  unidad_negocio_id
                }
              }
            `,
          })
          .then(({ data: { getCategorias } }) => {
            this.$store.dispatch('categoria/setCategorias', getCategorias);
          })
          .catch(() => []);
      },
      getSedes() {
        const qs = gql` query {getSedes ${''} {id, nombre,unidad_negocio, direccion, telefono1, telefono2, telefono_fijo, latitud, longitud, modelo_recibo, aulas {id}, ciudad{ id, nombre, departamento {nombre}}}}`;
        this.$apollo
          .query({ query: qs })
          .then(({ data: { getSedes } }) => {
            this.$store.dispatch('modsede/setSedes', getSedes.length ? getSedes : []);
          })
          .catch(() => []);
      },
      cargardata() {
        let unidad_negocio = 1;
        if (this.$store.state.CARGO) {
          unidad_negocio = this.$store.state.CARGO.sede.unidad_negocio;
        }
        if (unidad_negocio == 1) {
          this.$store.state.unidad.mision = process.env.VUE_APP_MISION_ESAM;
          this.$store.state.unidad.vision = process.env.VUE_APP_VISION_ESAM;
          this.$store.state.unidad.about = '';
          this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_ESAM;
          this.$store.state.unidad.postgrados = 'Postgrados';
          this.$store.state.unidad.programas = 'Programas';
        } else if (unidad_negocio == 2) {
          this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CCA;
          this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CCA;
          this.$store.state.unidad.about = '';
          this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CCA;
          this.$store.state.unidad.postgrados = 'Carreras';
          this.$store.state.unidad.programas = 'Cursos';
        } else if (unidad_negocio == 3) {
          this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CK;
          this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CK;
          this.$store.state.unidad.about = '';
          this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CK;
          this.$store.state.unidad.postgrados = 'Carreras';
          this.$store.state.unidad.programas = 'Cursos';
        } else if (unidad_negocio == 4) {
          this.$store.state.unidad.mision = process.env.VUE_APP_MISION_CAS;
          this.$store.state.unidad.vision = process.env.VUE_APP_VISION_CAS;
          this.$store.state.unidad.about = '';
          this.$store.state.unidad.logo = process.env.VUE_APP_LOGO_CAS;
          this.$store.state.unidad.postgrados = 'Niveles';
          this.$store.state.unidad.programas = 'Cursos Cas';
        }
        window.console.log(this.$store.state.CARGO.sede);
      },
      perfil() {
        window.sessionStorage.setItem('xperfil', JSON.stringify(this.$store.state.DATA_USER));
        this.$router.push({ name: 'perfil' });
      },
      salir() {
        window.localStorage.clear();
        window.sessionStorage.clear();
        this.$store.state.isLogin = false;
        //window.location.reload();
        this.activado = false;
        // window.location.href = "/portal"
        window.location.href = this.redirect;
      },
      parseMenus() {
        var vue = this;
        this.$store.state.MENUS = [];
        if (this.$store.state.CARGO == null) {
          window.console.error('CARGO NULO');
          return;
        }
        vue.$store.state.MENUS.push({ id: -1, nombre: 'Cargos', enlace: '-1', icono: '', visualizar: true });
        vue.$store.state.MENUS.push({ id: -2, nombre: 'Mis inscripciones', enlace: '-1', icono: '', visualizar: true });
        vue.$store.state.MENUS.push({ id: -3, nombre: 'Postgrados', enlace: '-1', icono: '', visualizar: true });
        vue.$store.state.MENUS.push({ id: -4, nombre: 'Facturas', enlace: '-1', icono: '', visualizar: true });
        vue.$store.state.MENUS.push({ id: -5, nombre: 'Dashboard', enlace: '-1', icono: '', visualizar: true });
      },
    },
    mounted() {
      this.getme();
    },
  };
</script>
